import type React from 'react';
import { useEffect, useState } from 'react';
import { calculateShowOnBottom } from '../components/Tooltip/utils';

const useTooltipShowOnBottom = <T extends HTMLElement = HTMLElement>(
  tooltipRef: React.RefObject<T | null>,
  showTooltip: boolean,
  isMobile?: boolean
) => {
  const [showOnBottom, setShowOnBottom] = useState(false);

  useEffect(() => {
    const shouldShowOnBottom = showTooltip && tooltipRef?.current && !showOnBottom;

    if (!showTooltip) {
      setShowOnBottom(false);
      return;
    }

    if (shouldShowOnBottom) {
      setShowOnBottom(calculateShowOnBottom(tooltipRef, isMobile));
    }
  }, [tooltipRef?.current, showTooltip]);

  return {
    showOnBottom,
  };
};

export default useTooltipShowOnBottom;
